function getPassthroughProps(component) {
  let propTypes = Object.getPrototypeOf(component).constructor.propTypes || {};
  return pick(component.props, k => Object.keys(propTypes).indexOf(k) < 0);
}

export { getPassthroughProps };

function pick(obj, predicate) {
  let parts = Object.keys(obj)
    .filter(predicate)
    .map(k => ({ [k]: obj[k] }));
  return Object.assign({}, ...parts);
}

let def = {
  getPassthroughProps: getPassthroughProps
};

export default def;